// Section background colors  SECTION_COLORS
//export const THEME_SUB = {
//    PRIMARY: '#f5f5f5',    // White background ( or not )ffffff
//    SECONDARY: '#f5f5f5', // Light gray for contrast sections
//    ACCENT: '#f5f5f5'     // Slightly different gray for special sections
//} as const;

// Other color constants can be added here
export const THEME_CONSTANTS = {
    LINK_ORANGE: '#FFA500', // For clickable elements
    BLACK: '#000000',
    OFF_BLACK: '#666666',
    OFF_WHITE: '#f9f9f9',
    WHITE: '#ffffff'
} as const;


// Column 1: Light gray-blue palette
export const GRAY_BLUE = {
    LIGHTEST: '#e8ecef',  // Very light gray-blue
    LIGHTER: '#c9c5ce',   // Light gray-blue
    LIGHT: '#a4b4c0',     // Medium-light gray-blue
    BASE: '#8fa3b1',      // Base gray-blue color
    MEDIUM: '#7a91a2',    // Medium gray-blue
    MEDIUM_DARK: '#6680a3',  // Medium-dark gray-blue
    DARK: '#493b69',      // Dark gray-blue
    DARKER: '#3a4954',    // Darker gray-blue
    DARKEST: '#2b363f',   // Very dark gray-blue
    DEEPEST: '#1d242a'    // Deepest gray-blue
} as const;

// Column 2: Navy blue palette
export const NAVY = {
    LIGHTEST: '#b0bbd8',  // Very light navy
    LIGHTER: '#98a7cc',   // Light navy
    LIGHT: '#809ac1',     // Medium-light navy
    BASE: '#687ab5',      // Base navy color
    MEDIUM: '#516aa7',    // Medium navy
    MEDIUM_DARK: '#3a4c77', // Medium-dark navy
    DARK: '#2e3c5f',      // Dark navy
    DARKER: '#263c5f',    // Darker navy
    DARKEST: '#232d47',   // Very dark navy
    DEEPEST: '#171c2f'    // Deepest navy
} as const;

// ** PRIMARY - Column 3: Blue-teal palette
export const BLUE_TEAL = {
    LIGHTEST: '#9fb5cc',  // Very light blue-teal
    LIGHTER: '#94fc69',   // Light blue-teal
    LIGHT: '#97b4cd',     // Medium-light blue-teal
    BASE: '#7fa3c2',      // Base blue-teal color
    MEDIUM: '#5980a9',    // Medium blue-teal
    MEDIUM_DARK: '#456091', // Medium-dark blue-teal
    DARK: '#395b78',      // Dark blue-teal
    DARKER: '#264960',    // Darker blue-teal
    DARKEST: '#223648',   // Very dark blue-teal
    DEEPEST: '#172430'    // Deepest blue-teal
} as const;

// Column 4: Royal blue palette
export const ROYAL_BLUE = {
    LIGHTEST: '#8cabfc',  // Very light royal blue
    LIGHTER: '#6991fb',   // Light royal blue
    LIGHT: '#4678fa',     // Medium-light royal blue
    BASE: '#235efa',      // Base royal blue color
    MEDIUM: '#0547f4',    // Medium royal blue
    MEDIUM_DARK: '#0333ee', // Medium-dark royal blue
    DARK: '#0328bb',      // Dark royal blue
    DARKER: '#021e68',    // Darker royal blue
    DARKEST: '#011445',   // Very dark royal blue
    DEEPEST: '#000a22'    // Deepest royal blue
} as const;

// Column 5: Gray palette
export const GRAY = {
    LIGHTEST: '#a1a5a9',  // Very light gray
    LIGHTER: '#c1c4c6',   // Light gray
    LIGHT: '#9caba4',     // Medium-light gray
    BASE: '#898e93',      // Base gray color
    MEDIUM: '#777c82',    // Medium gray
    MEDIUM_DARK: '#66666f', // Medium-dark gray
    DARK: '#55595d',      // Dark gray
    DARKER: '#44474a',    // Darker gray
    DARKEST: '#333537',   // Very dark gray
    DEEPEST: '#222325'    // Deepest gray
} as const;

// New maritime-focused color palette
export const MARITIME = {
    // Blues - from deep sea to sky
    NAVY: '#0A2342',         // Deep navy blue (ocean depths)
    STEEL_BLUE: '#2D5F8A',   // Steel blue (reliable, professional) - ORIGINAL
    PROFESSIONAL_BLUE: '#4378B0', // Lighter professional blue (15-20% lighter than steel blue)
    CLEAR_BLUE: '#4B88C9',   // Clear blue (bright ocean water)
    SKY_BLUE: '#8EB8E5',     // Sky blue (horizon)
    LIGHT_BLUE: '#C5D8EA',   // Light blue (seafoam)

    // Neutrals - like boat decks and sails
    WHITE: '#FFFFFF',        // Pure white (sails)
    BODY_BACKGROUND: '#FAFBFC', // Very light gray for body (lighter than off-white)
    OFF_WHITE: '#F7F9FA',    // Off-white (weathered sail)
    LIGHT_GRAY: '#E5E9EC',   // Light gray (cloud)
    MEDIUM_GRAY: '#ADB5BD',  // Medium gray (deck)
    DARK_GRAY: '#495057',    // Dark gray (weathered wood)

    // Accents
    SUNSET_ORANGE: '#FF8C3E', // Vibrant sunset orange (more vibrant)
    ORANGE: '#FF6B35',       // Bright orange (original)
    DEEP_ORANGE: '#E44D26',  // Deeper orange (sunset)

    // Functional
    SUCCESS: '#28A745',      // Success green
    WARNING: '#FFC107',      // Warning yellow
    DANGER: '#DC3545',       // Danger red
    INFO: '#4B88C9'          // Info blue
} as const;

// Define properly structured theme objects for Material UI
export const THEME_BLUE = {
    primary: {
        main: MARITIME.STEEL_BLUE,
        dark: MARITIME.NAVY,
        light: MARITIME.CLEAR_BLUE,
        contrastText: MARITIME.WHITE
    },
    secondary: {
        main: MARITIME.ORANGE,
        dark: MARITIME.DEEP_ORANGE,
        light: MARITIME.SUNSET_ORANGE,
        contrastText: MARITIME.WHITE
    },
    background: {
        default: MARITIME.OFF_WHITE,
        paper: MARITIME.WHITE
    },
    text: {
        primary: MARITIME.DARK_GRAY,
        secondary: MARITIME.STEEL_BLUE
    },
    orange: {
        main: MARITIME.ORANGE,
        dark: MARITIME.DEEP_ORANGE,
        light: MARITIME.SUNSET_ORANGE
    },
    typography: {
        h4: {
            color: MARITIME.NAVY
        },
        h6: {
            color: MARITIME.STEEL_BLUE
        },
        sectionTitle: {
            color: MARITIME.NAVY
        },
        footerHeader: {
            color: MARITIME.LIGHT_BLUE
        }
    },
    components: {
        button: {
            backgroundColor: MARITIME.ORANGE,
            hoverColor: MARITIME.DEEP_ORANGE
        },
        appBar: {
            backgroundColor: MARITIME.PROFESSIONAL_BLUE  // Using lighter blue
        },
        toggleButton: {
            selectedBackground: MARITIME.STEEL_BLUE,
            selectedColor: MARITIME.WHITE,
            hoverBackground: MARITIME.CLEAR_BLUE
        },
        MuiButton: {
            styleOverrides: {
                root: {
                    borderRadius: 4,
                    backgroundColor: MARITIME.ORANGE
                },
                contained: {
                    backgroundColor: MARITIME.ORANGE,
                    '&:hover': {
                        backgroundColor: MARITIME.DEEP_ORANGE
                    }
                },
                outlined: {
                    borderColor: MARITIME.CLEAR_BLUE,
                    '&:hover': {
                        backgroundColor: MARITIME.LIGHT_GRAY
                    }
                }
            }
        },
        MuiAppBar: {
            styleOverrides: {
                root: {
                    backgroundColor: MARITIME.PROFESSIONAL_BLUE  // Using lighter blue
                }
            }
        },
        MuiToggleButton: {
            styleOverrides: {
                root: {
                    backgroundColor: MARITIME.WHITE,
                    color: MARITIME.DARK_GRAY,
                    '&:hover': {
                        backgroundColor: MARITIME.LIGHT_BLUE
                    },
                    '&.Mui-selected': {
                        backgroundColor: MARITIME.STEEL_BLUE,
                        color: MARITIME.WHITE,
                        '&:hover': {
                            backgroundColor: MARITIME.NAVY
                        }
                    }
                }
            }
        },
        MuiCard: {
            styleOverrides: {
                root: {
                    borderColor: MARITIME.CLEAR_BLUE
                }
            }
        },
        MuiPaper: {
            styleOverrides: {
                root: {
                    backgroundColor: MARITIME.WHITE
                }
            }
        }
    },
    customColors: {
        linkOrange: THEME_CONSTANTS.LINK_ORANGE,
        highlight: {
            lightest: MARITIME.LIGHT_BLUE,
            lighter: MARITIME.SKY_BLUE,
            medium: MARITIME.CLEAR_BLUE,
            dark: MARITIME.STEEL_BLUE,
            darker: MARITIME.NAVY
        },
        result: MARITIME.WHITE,
        resultAlt: MARITIME.LIGHT_GRAY,
        buttonBackground: MARITIME.ORANGE,
        buttonHover: MARITIME.DEEP_ORANGE,
        appBarBackground: MARITIME.STEEL_BLUE,
        toggleSelected: THEME_CONSTANTS.WHITE,
        toggleSelectedText: MARITIME.STEEL_BLUE,
        toggleHover: MARITIME.STEEL_BLUE,
    }
} as const;

export const THEME_DARK = {
    palette: {
        mode: 'dark',
        primary: {
            main: MARITIME.NAVY,
            dark: '#071629', // Darker than navy
            light: MARITIME.STEEL_BLUE,
            contrastText: MARITIME.WHITE
        },
        secondary: {
            main: MARITIME.DEEP_ORANGE,
            dark: '#C43E1C', // Darker orange
            light: MARITIME.SUNSET_ORANGE,
            contrastText: MARITIME.WHITE
        },
        background: {
            default: '#121212', // Dark background
            paper: '#1E1E1E'    // Slightly lighter dark
        },
        text: {
            primary: MARITIME.WHITE,
            secondary: MARITIME.LIGHT_BLUE
        },
        orange: {
            main: MARITIME.ORANGE,
            dark: MARITIME.DEEP_ORANGE,
            light: MARITIME.SUNSET_ORANGE
        },
        customColors: {
            linkOrange: MARITIME.DEEP_ORANGE, // Darker for dark theme
            highlight: {
                lightest: MARITIME.LIGHT_BLUE,
                lighter: MARITIME.SKY_BLUE,
                medium: MARITIME.CLEAR_BLUE,
                dark: MARITIME.STEEL_BLUE,
                darker: MARITIME.NAVY
            },
            result: MARITIME.WHITE,
            resultAlt: '#2A2A2A', // Darker alternative for dark theme
            buttonBackground: MARITIME.ORANGE,
            buttonHover: MARITIME.DEEP_ORANGE,
            appBarBackground: MARITIME.STEEL_BLUE,
            toggleSelected: THEME_CONSTANTS.WHITE,
            toggleSelectedText: MARITIME.STEEL_BLUE,
            toggleHover: MARITIME.STEEL_BLUE,
        }
    },
    typography: {
        h4: {
            color: MARITIME.LIGHT_BLUE
        },
        h6: {
            color: MARITIME.SKY_BLUE
        },
        sectionTitle: {
            color: MARITIME.LIGHT_BLUE
        },
        footerHeader: {
            color: MARITIME.SKY_BLUE
        }
    },
    components: {
        MuiButton: {
            styleOverrides: {
                root: {
                    backgroundColor: MARITIME.DEEP_ORANGE,
                    '&:hover': {
                        backgroundColor: '#C43E1C'
                    }
                },
                contained: {
                    backgroundColor: MARITIME.DEEP_ORANGE,
                    '&:hover': {
                        backgroundColor: '#C43E1C'
                    }
                },
                outlined: {
                    borderColor: MARITIME.STEEL_BLUE,
                    '&:hover': {
                        backgroundColor: '#2A2A2A'
                    }
                }
            }
        },
        MuiAppBar: {
            styleOverrides: {
                root: {
                    backgroundColor: MARITIME.NAVY
                }
            }
        },
        MuiToggleButton: {
            styleOverrides: {
                root: {
                    backgroundColor: '#1E1E1E',
                    color: MARITIME.LIGHT_GRAY,
                    '&:hover': {
                        backgroundColor: '#2A2A2A'
                    },
                    '&.Mui-selected': {
                        backgroundColor: MARITIME.NAVY,
                        color: MARITIME.WHITE,
                        '&:hover': {
                            backgroundColor: '#071629'
                        }
                    }
                }
            }
        },

        MuiCard: {
            styleOverrides: {
                root: {
                    borderColor: MARITIME.STEEL_BLUE
                }
            }
        },
        MuiPaper: {
            styleOverrides: {
                root: {
                    backgroundColor: '#1E1E1E'
                }
            }
        }
    }
} as const;

export const THEME_MARITIME = {
    palette: {
        primary: {
            main: MARITIME.STEEL_BLUE,
            dark: MARITIME.NAVY,
            light: MARITIME.CLEAR_BLUE,
            contrastText: MARITIME.NAVY  // Changed to navy for white header
        },
        secondary: {
            main: MARITIME.ORANGE,
            dark: MARITIME.DEEP_ORANGE,
            light: MARITIME.SUNSET_ORANGE,
            contrastText: THEME_CONSTANTS.WHITE
        },
        background: {
            default: MARITIME.BODY_BACKGROUND,  // Very subtle gray body background
            paper: MARITIME.WHITE
        },
        text: {
            primary: MARITIME.DARK_GRAY,
            secondary: MARITIME.STEEL_BLUE
        },
        // Custom colors that can be accessed via theme.palette.customColors
        customColors: {
            linkOrange: THEME_CONSTANTS.LINK_ORANGE,
            highlight: {
                lightest: MARITIME.LIGHT_BLUE,
                lighter: MARITIME.SKY_BLUE,
                medium: MARITIME.CLEAR_BLUE,
                dark: MARITIME.STEEL_BLUE,
                darker: MARITIME.NAVY
            },
            result: MARITIME.WHITE,
            resultAlt: MARITIME.LIGHT_GRAY,
            buttonBackground: MARITIME.ORANGE,
            buttonHover: MARITIME.DEEP_ORANGE,
            appBarBackground: MARITIME.OFF_WHITE,  // Soft off-white header (less harsh than pure white)
            toggleSelected: THEME_CONSTANTS.WHITE,
            toggleSelectedText: MARITIME.STEEL_BLUE,
            toggleHover: MARITIME.STEEL_BLUE,
            toggleHoverBackground: MARITIME.LIGHT_BLUE,
            toggleUnselected: MARITIME.LIGHT_GRAY,
        },
        mode: 'light',
        orange: {
            main: MARITIME.ORANGE,
            dark: MARITIME.DEEP_ORANGE,
            light: MARITIME.SUNSET_ORANGE
        }
    },
    typography: {
        h4: {
            color: MARITIME.NAVY
        },
        h6: {
            color: MARITIME.NAVY
        },
        sectionTitle: {
            color: MARITIME.NAVY
        },
        footerHeader: {
            color: MARITIME.STEEL_BLUE
        }

    },
    // Component styling
    components: {
        MuiAppBar: {
            styleOverrides: {
                root: {
                    backgroundColor: MARITIME.OFF_WHITE, // Soft off-white header (less harsh than pure white)
                    boxShadow: '0 2px 4px rgba(0,0,0,0.1)', // Add subtle shadow for definition
                }
            }
        },
        MuiButton: {
            styleOverrides: {
                root: {
                    borderRadius: 4
                },
                contained: {
                    backgroundColor: MARITIME.ORANGE, // BUTTON_BACKGROUND_MEDIUM
                    '&:hover': {
                        backgroundColor: MARITIME.DEEP_ORANGE // BUTTON_BACKGROUND_DARK
                    }
                },
                outlined: {
                    borderColor: MARITIME.CLEAR_BLUE, // BORDER_MEDIUM
                    '&:hover': {
                        backgroundColor: MARITIME.LIGHT_GRAY // BACKGROUND_LIGHTEST
                    }
                }
            }
        },
        MuiToggleButton: {
            styleOverrides: {
                root: {
                    backgroundColor: MARITIME.CLEAR_BLUE, // TOGGLE_BACKGROUND
                    color: MARITIME.NAVY, // TOGGLE_TEXT_COLOR
                    '&:hover': {
                        backgroundColor: MARITIME.LIGHT_BLUE // TOGGLE_HOVER_BACKGROUND
                    },
                    '&.Mui-selected': {
                        backgroundColor: MARITIME.NAVY, // TOGGLE_SELECTED_BACKGROUND  THEME_ACTIVE.TOGGLE_SELECTED_BACKGROUND
                        color: MARITIME.WHITE, // TOGGLE_SELECTED_TEXT
                        '&:hover': {
                            backgroundColor: MARITIME.STEEL_BLUE // Slightly darker on hover when selected
                        }
                    }
                }
            }
        },
        MuiCard: {
            styleOverrides: {
                root: {
                    borderColor: MARITIME.CLEAR_BLUE // BORDER_MEDIUM
                },
                outlined: {
                    borderColor: MARITIME.CLEAR_BLUE
                }
            }
        },
        MuiPaper: {
            styleOverrides: {
                root: {
                    backgroundColor: MARITIME.WHITE
                }
            }
        }
    },


};
// Export the active theme for easier reference throughout the application
export const THEME_ACTIVE = THEME_MARITIME;